import { render, staticRenderFns } from "./BAT.vue?vue&type=template&id=335d9a3b&scoped=true&"
import script from "./BAT.vue?vue&type=script&lang=js&"
export * from "./BAT.vue?vue&type=script&lang=js&"
import style0 from "./BAT.vue?vue&type=style&index=0&id=335d9a3b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "335d9a3b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VDataTable,VTextField})
